import { MainLoader, ResourceLoader, ResourceLoaderProps } from 'ia-react-core';
import React, { FC } from 'react';
import { useSitecoreJssQuery } from 'omni-package-react-cms';

export interface TermsOfUseContentLoaderProps extends ResourceLoaderProps<unknown> { }

const TermsOfUseContentLoader: FC<TermsOfUseContentLoaderProps> = ({ ...props }) => {
  const url = useSitecoreJssQuery('/profile/electronic-services-terms-of-use');
  return (
    <ResourceLoader
      autoRequest
      name="termsOfUseResource"
      url={url}
      inlineErrorMessage={false}
      buttonAlign="left"
      dataDst="termsOfUseContent"
      CustomLoader={MainLoader}
      config={{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        transformResponse: (data) => data?.sitecore?.route?.fields?.Body?.value,
      }}
      {...props}
    />
  );
};

export default TermsOfUseContentLoader;
